import { Component, OnInit, ViewChildren, QueryList, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { advertisement, ServiceService } from '../service.service';
import { ModalController, LoadingController, Platform, NavParams, IonInfiniteScroll } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { NotificacionesPage } from '../notificaciones/notificaciones.page';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { StreamingMedia, StreamingVideoOptions } from '@ionic-native/streaming-media/ngx';
import { PointEarnedUser } from '../badges/badges-utils';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';
import { EmailComposer } from '@ionic-native/email-composer/ngx';
import { OneSignal } from '@ionic-native/onesignal/ngx';

@Component({
  selector: 'app-bienvenido',
  templateUrl: './bienvenido.page.html',
  styleUrls: ['./bienvenido.page.scss', '../../assets/scss/styles.scss'],
})

export class BienvenidoPage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  contador = 1;
  showVideoPub:boolean = false;
  urlVideoPub:String;

  constructor(
    public services: ServiceService,
    public modalController: ModalController,
    public storage: Storage,
    private router: Router,
    private loadingController: LoadingController,
    private callNumber: CallNumber,
    private screenOrientation: ScreenOrientation,
    private streamingMedia: StreamingMedia,
    private platform: Platform,
    private firebaseAnalytics: FirebaseAnalytics,
    private emailComposer: EmailComposer,
    private oneSignal: OneSignal
  ) {
    // this.bringUserInformation();
    this.firebaseAnalytics.logEvent;
    this.firebaseAnalytics.setCurrentScreen("Bienvenido");
    this.getPoints();
    this.initializeApp();
  }
  // Campos de la clase
  user;
  stars;
  notifications;
  imageURL;
  id;
  token;
  arrayNotification;
  frameUrl;
  showPerfile: boolean;
  message: string;
  userStatus = 1;
  friendCode:string;
  progress:number
  maxPointLevel:number;
  pointsCount:number;
  frame:string;
  promotionalsBanners:Array<any> = new Array();
  edited:boolean=false;
  level:string;
  color:string;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();
  
  async ngOnInit() {
    // Call a method from other class
    this.isMovil = this.services.isMovil();
    this.services.syncUp.subscribe(() => {
      this.bringUserInformation();
    });
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(4);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  async scrollingAds(event:any) {
    let rows = Math.floor(Number(event.detail.scrollTop-this.advertisements.SizePage)/this.advertisements.SizeDivImage);
    let final = rows+this.advertisements.Rows;
    if(event.detail.scrollTop > this.advertisements.SizePage && rows>0 && final > this.advertisements.Displayed.length && this.advertisements.Displayed.length < this.advertisements.MediaBasico.length){
      let displayedLength = this.advertisements.Displayed.length;
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,final);
      let disply = this.advertisements.Displayed.slice(displayedLength,this.advertisements.Displayed.length);
      this.services.postAdvertisementUser(this.advertisements.getRelAdsMetricsId(disply));
    }
  }

  initializeApp() {
    this.platform.ready().then(()=> {
      this.setupPush();
    });
  }

  setupPush() {
    // I recommend to put these into your environment.ts
    this.oneSignal.startInit('ac5cca1e-1623-4144-95c2-b481605564ea', '576684940504');
 
    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.None);
 
    // Notifcation was received in general
    this.oneSignal.handleNotificationReceived().subscribe(data => {
      let msg = data.payload.body;
      let title = data.payload.title;
      let additionalData = data.payload.additionalData;
      //this.showAlert(title, msg, additionalData.task);
    });
 
    // Notification was really clicked/opened
    this.oneSignal.handleNotificationOpened().subscribe(data => {
      // Just a note that the data is a different place here!
      let additionalData = data.notification.payload.additionalData;
 
      //this.showAlert('Notification opened', 'You already read this before', additionalData.task);
    });
    this.oneSignal.sendTag("user_type","Home");
    this.oneSignal.setLogLevel({logLevel: 6, visualLevel: 0});
    this.oneSignal.endInit();

  }

  ionViewWillEnter() {
    this.bringUserInformation();
  }

  private async bringUserInformation() {
    const loading = await this.loadingController.create({
      message: 'Espere por favor ...', duration: 6000
    });

    await loading.present();
        this.services.homeUser().subscribe(
          data => {
            if(data["active"] != 2){
              this.progress = data['progress'] || 0;
              this.maxPointLevel = data['maxPointLevel'] || 0;
              this.pointsCount = data['pointsCount'] || 0;
              this.level = data['level'];
              this.color = data['color'] || '#cd7f32';
              this.promotionalsBanners = data['promotionalsBanners'] || new Array();
              this.frame = data['frame'] || "https://test-bucket-72bc5c3f-5c53-4442-9610-58d5c984afb1.s3.amazonaws.com/Frames/bronce-0.svg";
              if(this.frame) this.frame+'?123456789';
              localStorage.setItem('friendCode', data['friendCode']);
              if (data['name'] === '') {
                this.storage.get('email').then((email) => {
                  this.user = 'usuario';
                  this.imageURL = data['imageUrl'];
                  this.showPerfile = true;
                  this.message = 'completar perfil';
                  this.notifications = 1;
                  this.arrayNotification = data['notifications'];
                });
              } else {
                this.user = data['name'] + ' ' + data['lastName'];
                this.stars = data['ranking'];
                this.arrayNotification = data['notifications'];
                this.notifications = this.arrayNotification.length;
                this.imageURL = data['imageUrl'];
                this.showPerfile = false;
              }
              loading.dismiss();
              let previousLevel = localStorage.getItem('previousLevel');
              if(previousLevel!=null && Number(data['maxPointLevel'])>Number(previousLevel)){
                this.services.showAlert('¡Felicidades por subir de nivel, sigue compitiendo!');
              }
              localStorage.setItem('previousLevel', data['maxPointLevel']);
              this.routerComunidadCNC();
            }
            else{
              this.routerLogin();
            }
          },
          error => {
            this.routerLogin();
          }
          
        );
  }

  routerLogin() {
    this.router.navigate(['/login']);
  }
  routerComunidadCNC() {
    let accesNew = Number(localStorage.getItem("accesNew"));
    if(accesNew==1){
      //this.router.navigate(['/tab-forum']);
      // this.router.navigate(['/tab-forum']);
      localStorage.setItem("accesNew", "2");
    }
    
  }
  async openModal() {
    const modal = await this.modalController.create({
      component: NotificacionesPage,cssClass:(!this.services.isMovil())?'custom-modal':'',
      componentProps: { notifications: this.arrayNotification }
    });
    modal.onDidDismiss().then(data => {
      this.bringUserInformation();
    });
    return await modal.present();
  }
  async autoPlay() {
    
    if(this.platform.is('desktop') || this.platform.is('electron')){
      this.showVideoPub = true;
      this.urlVideoPub = String(this.promotionalsBanners[1]?.resourceUrl);
      
     }else{
      this.openDialog();
      const options: StreamingVideoOptions = {
        successCallback: () => { /* console.log('Video played'); */ },
        errorCallback: (e) => { /* console.log('Error streaming'); */ },
        orientation: 'landscape',
        shouldAutoClose: true,
        controls: true
      }
      this.streamingMedia.playVideo(String(this.promotionalsBanners[1]?.resourceUrl), options);
      if(!this.wasPlayed){
        this.wasPlayed = true;
        await this.services.savePromotionMetric([this.promotionalsBanners[0],this.promotionalsBanners[1]]);
      }
    };
  }
  public hideAds(){
    this.showVideoPub = false
  }

  async getPoints(){
    (await this.services.getPointsUser()).subscribe(
      (data:PointEarnedUser)=>{
        localStorage.setItem("PointEarnedUser", JSON.stringify(data));
      },
      (error) => {
        // console.log(error);
      }
    );
  }
  async openDialog() {
    const modal = await this.modalController.create({
      component: DialogContentExampleDialog,
      backdropDismiss : false,
      componentProps: { 
        video : String(this.promotionalsBanners[1]?.resourceUrl)
      }
    });
    modal.onDidDismiss().then(async data => {
      //await this.loadThreads();
    });
    return await modal.present();
  }
  public getNameImage(url:any ){
    if(!url) return 'assets/images/imgNotFound.jpeg';
    return String(url) + '?123456789'; 
  }

  public async openEmailDialog(item: any){
    await this.services.savePromotionMetric([item]);
    if(item?.bannerUrl){
      //window.open(item?.bannerUrl, '_system', 'location=yes');
      if(this.isMovil)
        this.openFrame(item?.bannerUrl);
      else if(!this.isMovil)
        window.open(item?.bannerUrl, "_blank");
      return;
    }

    const email = {
      to: String(item.email),
      cc: [],
      attachments: [],
      subject: String(item.mailAffair),
      body: String(item.mailBody),
      isHtml: false,
      app: "correo"
    };
    
    this.emailComposer.open(email);
  }

  public wasPlayed = false;
  public async saveMetricVideo(promotionVideo){
    if(!this.wasPlayed){
      this.wasPlayed = true;
      await this.services.savePromotionMetric([promotionVideo]);
    }
  }

  public openFrame(url : any ){

    if (this.platform.is('ios')) {
      var ifrm = document.createElement('iframe');
      ifrm.setAttribute('id', 'ifrm'); // assign an id
  
      // to place before another page element
      var el = document.getElementById('iframeHolder');
      el.parentNode.insertBefore(ifrm, el);
  
      // assign url
      ifrm.setAttribute('src', url);
      ifrm.setAttribute('width', '0px');
      ifrm.setAttribute('height', '0px');
    } else {
      window.open(url, '_system', 'location=yes')
    }


  }
} // Fin de clase Bienvenido

@Component({
  selector: 'dialog-content-example-dialog',
  templateUrl: 'dialog-content-example-dialog.html',
})
export class DialogContentExampleDialog {
  public video:string = "";
  constructor(
    public modalController: ModalController,
    private navParams: NavParams
  ) {
    
  }
  ionViewWillEnter() {
    this.video = this.navParams.get('video');
  }
  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  public getColorOfBar(level: any){
    let color:string = "red";

    switch (level) {
      case 'Bronce':
        color = "#bdbdbd";
        break;
      case 'Aluminio':
        color = "#bdbdbd";
        break;
      case 'Acero':
        color = "#bdbdbd";
        break;
            
      case 'Inoxidable':
        color = "#bdbdbd";
        break;

        case 'Titanio':
          color = "#bdbdbd";
          break;
      default:
        break;
    }
  }
}//Fin de clase
